module.exports = __webpack_public_path__ + "static/media/news-image-1.d0d1e9e1.png";